export const PRODUCTS = [
    {
        id: 'gf-021-nash-dom',
        name: 'ГФ-021 «Наш Дом»',
        image: 'https://static.tildacdn.com/stor3337-6162-4030-b531-373139376137/23255768.jpg'
    },
    {
        id: 'pf-115-nash-dom',
        name: 'ПФ-115 «Наш Дом»',
        image: 'https://static.tildacdn.com/stor3433-6137-4230-b236-386331613264/66790862.jpg'
    },
    {
        id: 'emal-dlya-pola-pf-266',
        name: 'Эмаль для пола ПФ-266 «Наш Дом»',
        image: 'https://static.tildacdn.com/stor3131-3033-4137-a366-333866303564/10934543.jpg'
    },
    {
        id: 'vd-ak-fasadnaya',
        name: '«Наш Дом» ВД АК Фасадная',
        image: 'https://static.tildacdn.com/stor3133-3565-4464-b264-383239383830/90498739.jpg'
    },
    {
        id: 'grunt-gf-021',
        name: 'Грунт ГФ-021',
        image: 'https://static.tildacdn.com/stor6237-3538-4632-b161-336233383062/27503150.jpg'
    },
    {
        id: 'grunt-bystrosohniy',
        name: 'Грунт быстросохнущий',
        image: 'https://static.tildacdn.com/stor6135-6134-4239-b163-666534666133/17263861.jpg'
    },
    {
        id: 'grunt-emal',
        name: 'Грунт-эмаль',
        image: 'https://static.tildacdn.com/stor3335-3264-4638-b165-353661386264/93694722.jpg'
    },
    {
        id: 'kraska-ma-15',
        name: 'Краска МА-15',
        image: 'https://static.tildacdn.com/stor3362-3962-4136-b230-343639326663/28055585.jpg'
    },
    {
        id: 'lak-parketniy',
        name: 'Лак Паркетный',
        image: 'https://static.tildacdn.com/stor3865-3631-4361-b935-356331616364/34328947.jpg'
    },
    {
        id: 'lak-yahtniy',
        name: 'Лак Яхтный',
        image: 'https://static.tildacdn.com/stor6638-3235-4135-b230-353662333738/19041866.jpg'
    },
    {
        id: 'lak-dekorativniy-antiseptik',
        name: 'Лак-декоративный антисептик',
        image: 'https://static.tildacdn.com/stor3964-3836-4662-b931-353166346339/97574181.jpg'
    },
    {
        id: 'emal-molotkovaya',
        name: 'Эмаль молотковая',
        image: 'https://static.tildacdn.com/stor3136-6435-4666-b730-353632393234/19993788.jpg'
    },
    {
        id: 'emal-pf-115',
        name: 'Эмаль ПФ-115',
        image: 'https://static.tildacdn.com/stor3936-6461-4331-b135-616630346432/69667357.jpg'
    },
    {
        id: 'emal-pf-266',
        name: 'Эмаль ПФ-266',
        image: 'https://static.tildacdn.com/stor6336-3437-4433-b633-633339333538/44162552.jpg'
    },
    {
        id: 'biozashita-antiplecen',
        name: 'Биозащита Антиплесень',
        image: 'https://static.tildacdn.com/stor6535-3735-4966-a264-323563396665/65585217.jpg'
    },
    {
        id: 'biozashita-zhukomor',
        name: 'Биозащита Жукомор',
        image: 'https://static.tildacdn.com/stor3836-3661-4238-a364-363032386535/29997192.jpg'
    },
    {
        id: 'kraska-interernaya',
        name: 'Краска интерьерная',
        image: 'https://static.tildacdn.com/stor3266-3762-4762-b237-616230636332/22793959.jpg'
    },
    {
        id: 'kraska-interernaya-moyushayasya',
        name: 'Краска интерьерная моющаяся',
        image: 'https://static.tildacdn.com/stor6532-3433-4538-b232-383335376136/20995069.jpg'
    },
    {
        id: 'kraska-dlya-potolkov',
        name: 'Краска для потолков',
        image: 'https://static.tildacdn.com/stor3832-3766-4663-b163-333165346535/43641966.jpg'
    },
    {
        id: 'kraska-dlya-sten-i-potolkov',
        name: 'Краска для стен и потолков',
        image: 'https://static.tildacdn.com/stor3330-3865-4533-b066-633163613635/22913162.jpg'
    },
    {
        id: 'kraska-dlya-sadovih-derevev',
        name: 'Краска для садовых деревьев',
        image: 'https://static.tildacdn.com/stor3463-3530-4232-a465-313734393538/19843946.jpg'
    },
    {
        id: 'kolevrovochnie-pasti-zlata',
        name: 'Колевровочные пасты « Zlata»',
        image: 'https://static.tildacdn.com/stor3432-3239-4130-b866-366464343532/50852961.jpg'
    },
    {
        id: 'gruntovka-vodnaya-akrilovaya-zlata',
        name: 'Грунтовка водная акриловая «Zlata» — составы для наружных и внутренних работ',
        image: 'https://static.tildacdn.com/stor6333-3764-4435-b863-613465366362/11988225.png'
    },
    {
        id: 'gruntovka-betokontakt',
        name: 'Грунтовка Бетоконтакт',
        image: 'https://static.tildacdn.com/stor6431-6336-4661-b637-376133336532/20349847.jpg'
    },
    {
        id: 'protivomoroznaya-dobavka',
        name: 'Противоморозная добавка',
        image: 'https://static.tildacdn.com/stor3561-3965-4562-b938-326535313237/56119719.png'
    },
    {
        id: 'plastifikator-ps-1',
        name: 'Пластификатор ПС-1',
        image: 'https://static.tildacdn.com/stor3432-3239-4130-b866-366464343532/50852961.jpg'
    },
    {
        id: 'zamazka-universalnaya',
        name: 'Замазка Универсальная',
        image: 'https://static.tildacdn.com/stor3039-3765-4837-a662-313864353138/36911458.jpg'
    },
    {
        id: 'shpatlevka-pobelka',
        name: 'Шпатлевка+побелка',
        image: 'https://static.tildacdn.com/stor6664-3434-4434-b266-633136316466/36320640.jpg'
    },
    {
        id: 'shpatlevka-lateksnaya-universalnaya',
        name: 'Шпатлевка латексная универсальная',
        image: 'https://static.tildacdn.com/stor6135-6537-4337-b130-316631393066/81248393.jpg'
    },
    {
        id: 'shpatlevka-maslyano-kleevaya',
        name: 'Шпатлевка масляно-клеевая',
        image: 'https://static.tildacdn.com/stor3664-6665-4639-b837-636465616662/57082448.jpg'
    },
    {
        id: 'shpatlevka-na-osnove-pva',
        name: 'Шпатлевка на основе ПВА',
        image: 'https://static.tildacdn.com/stor3630-3731-4265-b936-303038343431/74588117.jpg'
    },
    {
        id: 'shpatlevka-fasadnaya',
        name: 'Шпатлевка фасадная',
        image: 'https://static.tildacdn.com/stor3166-6562-4130-b465-346233383836/72216312.jpg'
    },
    {
        id: 'shpatlevka-po-derevu-ekstra',
        name: 'Шпатлевка по дереву «Экстра»',
        image: 'https://static.tildacdn.com/stor6431-3363-4430-b131-333365363066/39786847.jpg'
    },
    {
        id: 'emal-akrilovaya-termostoykaya',
        name: 'Эмаль Акриловая термостойкая',
        image: 'https://static.tildacdn.com/stor3365-3237-4164-a336-396236666439/56424909.jpg'
    },
    {
        id: 'mag-progress',
        name: 'MAG-(progress)',
        image: 'https://static.tildacdn.com/stor3432-3239-4130-b866-366464343532/50852961.jpg'
    },
    {
        id: 'smyvka-staroy-kraski-zlata',
        name: 'Смывка старой краски «Zlata»',
        image: 'https://static.tildacdn.com/stor3735-6361-4534-b961-666539396134/46486231.jpg'
    }
];
// Функции для работы с данными
export const getProductById = (id) => {
    return PRODUCTS.find(product => product.id === id);
};
export const searchProducts = (query) => {
    const lowerQuery = query.toLowerCase();
    return PRODUCTS.filter(product => product.name.toLowerCase().includes(lowerQuery));
};
export const getAllProducts = () => {
    return PRODUCTS;
};
